import { IChatMessage } from "@/models/aiInterfaces";
import {MessageType, ContentType, ChatKey, AskLevel} from "@/models/aiModels";

export const isNullOrEmptyArray = (value: any): boolean => {
    return value === null || value === undefined || (Array.isArray(value) && value.length === 0);
};

export const generateProductBriefQuestion = (askInput: any, contentType: ContentType): string => {
    let question = '<p>I am looking for a packaging solution with the following specifications: </p>';
    switch(contentType){
        case ContentType.JSON: {
            question += '<ul class="list-disc pl-5">';
            let jsonObj =JSON.parse(askInput);
            if(typeof jsonObj === 'string'){
                jsonObj = JSON.parse(jsonObj);
            }
            const productBrief = jsonObj.product_brief;
            
            question += '<ul class="list-disc pl-5">';
            for(const key in productBrief){
                if(productBrief[key] === null || productBrief[key] === undefined || (Array.isArray(productBrief[key]) && productBrief[key].length === 0) || productBrief[key] == false){
                    continue;
                }else{
                    question += `<li>${key}:&nbsp; ${productBrief[key]}</li>`;
                }
            }
            question += '</ul>';
            break;
        }
    }
    
    return question;
}

export const generateRegulationsQuestion = (askInput:any, contentType: ContentType): string => {
    switch(contentType){
        case ContentType.JSON: {
            let jsonObj =JSON.parse(askInput);
            if(typeof jsonObj === 'string'){
                jsonObj = JSON.parse(jsonObj);
            }
            if(jsonObj.level == AskLevel.START){
                return generateRegulationsStartQuestion(jsonObj.regulations);
            }
            else if(jsonObj.level == AskLevel.MODIFY){
                return generateRegulationsModifyQuestion(jsonObj.regulations_modify);
            }
        }
    }
    return null;
}

// generate regualations start question
const generateRegulationsStartQuestion = (regulations:object): string => {
    let question = '<p>Can you please look through packaging regulations with the following creteria: </p>';
    question += '<ul class="list-disc pl-5">';
    for(const key in regulations){
        if(regulations[key] === null || regulations[key] === undefined){
            continue;
        }else{
            question += `<li>${key}:&nbsp; ${regulations[key]}</li>`;
        }
    }
    question += '</ul>';
    return question;
}

// generate regulations modify question
const generateRegulationsModifyQuestion = (regualtionModify:object): string => {
    let question = '<p>I want to modify the following variables: </p>';
    question += '<ul class="list-disc pl-5">';
    for(const key in regualtionModify){
        if(regualtionModify[key] === null || regualtionModify[key] === undefined){
            continue;
        }else{
            question += `<li>${key}:&nbsp; ${regualtionModify[key]}</li>`;
        }
    }
    question += '</ul>';
    return question;
}

export const generateGeneralQuestion = (regulations: any): string => {
    let question = '';
    question += '<ul class="list-disc pl-5">';
    for(const key in regulations){
        if(regulations[key] === null || regulations[key] === undefined){
            continue;
        }else{
            question += `<li>${key}:&nbsp; ${regulations[key]}</li>`;
        }
    }
    question += '</ul>';
    return question;
}



/**
 * Creates a function that retrieves a value from a deeply nested state path within the Vuex store.
 * 
 * This function generates a getter function based on a given module and a nested path in the Vuex store. 
 * When the returned function is invoked, it will access and return the value at the specified nested state path.
 * 
 * @param {Object} store - The Vuex store instance, which contains the state.
 * @param {string} module - The Vuex module where the state is located. The module name is used to access the correct part of the state.
 * @param {string} base - The nested state path within the module, specified as a string with keys separated by '.' or '/'. 
 *                        For example, "somePath.subPath" or "somePath/subPath".
 * 
 * @returns {Function} A function that, when invoked, returns the value located at the nested state path. 
 *                     The function uses the `base` string to traverse the state object using the keys derived from splitting the `base` string.
 * 
 * @example
 * const getter = generateStatePathGetter(store, 'myModule', 'nested/path.to/value');
 * const value = getter(); // Retrieves the value from store.state.myModule.nested.path.to.value
 */
export function generateStatePathGetter(store,module,base){
    // Split by both '.' and '/'
    const baseKeys= base.split(/[./]/);
    
    // Return a function that will access the nested state when invoked
    return () => baseKeys.reduce((acc, key) => acc && acc[key], store.state[module]);
}


export const generateAIQuestion = (chatKey:ChatKey, chatMessage: IChatMessage): string => {
    let question = '';
    // ensure message is of a question type
    if(chatMessage.messageType === MessageType.QUESTION){
        //loop through the message contents
        chatMessage.messageContents.forEach(messageContent => {
            // call relevant chat key
            switch(chatKey){
                case ChatKey.REGULATIONS:
                    question += generateRegulationsQuestion(messageContent.content,messageContent.contentType);
                    break;
                case ChatKey.PRODUCTBRIEF:
                    question += generateProductBriefQuestion(messageContent.content, messageContent.contentType);
                    break;
                default:
                    question += generateGeneralQuestion(messageContent.content);
                    break;
            }
        });
    }
    return question;
}